import(/* webpackMode: "eager" */ "/App/src/app/global-error.tsx");
